<template>
  <div class="Correcting">
    <div class="container">
      <div class="space_between" style="margin-bottom: 16px">
        <span>关联单号：</span>
        <el-input
          v-model="order_sn"
          placeholder="请输入"
          style="width: 200px; margin: 0 16px 0 8px"
          @input="search"
          clearable
        ></el-input>
        <span>校正时间：</span>

        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          style="width: 225px; margin-right: 16px"
          @change="search"
          clearable
        ></el-date-picker>

        <el-button type="primary" size="medium" @click="search">查询</el-button>
        <el-button
          type="primary"
          size="medium"
          @click="showDia"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('484') : false
          "
          >添加校正</el-button
        >
      </div>
      <div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change="changeOrder"
          >
            <el-table-column
              prop="correct_time"
              label="校正时间"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="提交时间"
            ></el-table-column>
            <el-table-column
              prop="correct_desc"
              label="校正原因"
            ></el-table-column>
            <el-table-column prop="order_sn" label="关联单号"></el-table-column>
            <el-table-column
              prop="cost_price"
              label="提交时成本价"
            ></el-table-column>

            <el-table-column prop="price" label="提交时销售价">
              <template slot-scope="scope">
                <span>{{ scope.row.price }}元/g</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="correct_num"
              label="校正量"
              sortable="custom"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.correct_num">
                  <span>{{
                    Number(scope.row.correct_num) > 0 ? "+" : ""
                  }}</span>
                  <span>{{ scope.row.correct_num }}g</span>
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="price" label="是否新标用量">
              <template slot-scope="scope">
                <span>{{ !scope.row.is_national_standard ? "否" : "是" }}</span>
              </template>
            </el-table-column>

            <el-table-column label="图片" prop="correct_image" width="330">
              <template slot-scope="scope">
                <div class="flex">
                  <UploadImg
                    v-for="(item, index) in scope.row.correct_image_str"
                    :key="index"
                    :f_thumb="item"
                    :f_thumb_str="item"
                    :isDel="false"
                    style="margin-right: 10px"
                  ></UploadImg>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="delCorrectInfo(scope.row.correct_id)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('483')
                      : false
                  "
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center; padding-top: 20px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="添加校正"
      :visible.sync="dialog"
      width="530px"
      style="text-align: left"
      :close-on-click-modal="false"
    >
      <div class="dialogbox">
        <div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item prop="correct_time" label="校正时间">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="ruleForm.correct_time"
                style="width: 240px"
              ></el-date-picker>
            </el-form-item>
            <el-form-item prop="hospital_id" label="选择药房">
              <el-select
                v-model="ruleForm.hospital_id"
                placeholder="请选择"
                style="width: 240px"
                :disabled="hospital_id ? true : false"
              >
                <el-option
                  v-for="item in hospitalList"
                  :key="item.hospital_id"
                  :label="item.hospital_name"
                  :value="item.hospital_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="dosage_form" label="选择剂型">
              <el-select
                v-model="ruleForm.dosage_form"
                placeholder="请选择"
                style="width: 240px"
                :disabled="dosage_form ? true : false"
              >
                <el-option
                  v-for="item in drugTypeList"
                  :key="item.dosage_form"
                  :label="item.drug_type_name"
                  :value="item.dosage_form"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="校正原因" prop="correct_desc">
              <el-select
                v-model="ruleForm.correct_desc"
                placeholder="请选择"
                style="width: 240px"
              >
                <el-option label="多发药物" value="多发药物"></el-option>
                <el-option label="实际未发" value="实际未发"></el-option>
                <el-option label="少发药物" value="少发药物"></el-option>
                <el-option label="错发药物" value="错发药物"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="校正剂量" prop="num">
              <el-select
                v-model="ruleForm.num_symbol"
                placeholder="请选择"
                style="width: 60px"
              >
                <el-option label="+" value="+"></el-option>
                <el-option label="-" value="-"></el-option>
              </el-select>
              <el-input-number
                v-model="ruleForm.num"
                placeholder="正数加量，负数减量"
                :controls="false"
                style="width: 170px; margin-left: 10px"
                :min="0"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="关联单号" prop="order_sn">
              <el-input
                v-model="ruleForm.order_sn"
                style="width: 240px"
                placeholder="请输入关联发药订单"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="图片上传"
              prop="correct_image"
              class="correct-image"
            >
              <div class="image-box">
                <UploadImg @emitImg="emitImg"></UploadImg>
                <UploadImg @emitImg="emitImg"></UploadImg>
                <UploadImg @emitImg="emitImg"></UploadImg>
              </div>
            </el-form-item>

            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="ruleForm.remark"
                style="width: 240px"
                placeholder="请输入，如相关药品信息等"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: right; margin-top: 20px">
          <el-button
            type="primary"
            style="width: 92px"
            @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import _ from "lodash";
import UploadImg from "@/components/uploadImg/index";
export default {
  components: {
    UploadImg,
  },
  props: {
    info: {
      require: true,
      type: Object,
    },
  },
  data() {
    return {
      goods_id: this.$route.query.goods_id,
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      orderby: 0,
      order_sn: "",
      date: "",
      dialog: false,
      hospitalList: [],
      drugTypeList: [], //剂型列表
      drug_id: "",
      hospital_id: "",
      dosage_form: "",
      type: "",
      ruleForm: {
        correct_time: "",
        correct_desc: "",
        num_symbol: "+",
        num: undefined,
        order_sn: "",
        remark: "",
        hospital_id: "",
        dosage_form: "",
        goods_id: this.$route.query.goods_id,
        correct_image: [],
      },
      rules: {
        correct_time: [
          { required: true, message: "请输入校正时间", trigger: "blur" },
        ],
        correct_desc: [
          { required: true, message: "请选择校正原因", trigger: "blur" },
        ],
        num: [{ required: true, message: "请输入校正数量", trigger: "blur" }],
        hospital_id: [
          { required: true, message: "请选择药房", trigger: "blur" },
        ],
        dosage_form: [
          { required: true, message: "请选择剂型", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.drug_id = this.$route.query.drug_id;
    this.hospital_id = this.$route.query.hospital_id;
    this.drug_type_pid = this.$route.query.drug_type_pid;
    this.dosage_form = this.$route.query.dosage_form;
    this.type = this.$route.query.type;
    this.initDate();
    this.getList();
    setTimeout(() => {
      this.getHdDrugTypeList(); //获取剂型列表
      this.getHospitalList(); //获取药房列表
    }, 200);
  },
  methods: {
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      end = dayjs(end).format("YYYY-MM-DD");
      start = dayjs(start).format("YYYY-MM-DD");
      this.date = [start, end];
    },
    //获取列表
    getList() {
      let data = {};
      let url = "";
      if (this.type == 1) {
        data = {
          page: this.currentPage,
          pageNumber: this.pagesize,
          drug_id: this.drug_id,
          hospital_id: this.hospital_id,
          drug_type_pid: this.drug_type_pid,
          order_sn: this.order_sn,
          orderby: this.orderby,
        };
        url = "platform/hospital/getHospitalpidCorrectList";
      }
      if (this.type == 2) {
        data = {
          page: this.currentPage,
          pageNumber: this.pagesize,
          drug_id: this.drug_id,
          dosage_form: this.dosage_form,
          order_sn: this.order_sn,
          orderby: this.orderby,
        };
        url = "platform/hospital/getCorrectList";
      }
      if (this.type == 3) {
        data = {
          page: this.currentPage,
          pageNumber: this.pagesize,
          drug_id: this.drug_id,
          dosage_form: this.dosage_form,
          order_sn: this.order_sn,
          orderby: this.orderby,
          hospital_id: this.hospital_id,
        };
        url = "platform/hospital/getCorrectList";
      }
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.create_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios.post(url, data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.correct_time = dayjs
              .unix(item.correct_time)
              .format("YYYY-MM-DD");
            item.create_time = dayjs
              .unix(item.create_time)
              .format("YYYY-MM-DD");
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //更改顺序
    changeOrder(value) {
      let order = value.order;
      let prop = value.prop;
      //升序
      if (order == "ascending") {
        if (prop == "correct_num") {
          this.orderby = 1;
        }
      }
      //降序
      if (order == "descending") {
        if (prop == "correct_num") {
          this.orderby = 2;
        }
      }
      if (!order) {
        this.orderby = 0;
      }
      this.getList(orderby);
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //药房列表
    getHospitalList() {
      if (this.dosage_form) {
        let data = {
          drug_id: this.drug_id,
          dosage_form: this.dosage_form,
        };
        this.axios
          .post("platform/hospital/getHdHospitalList", data)
          .then((res) => {
            this.hospitalList = res.data;
          });
      } else {
        let data = {
          org_type: 0,
          hospiatl_type: 0,
          page: 1,
          pageNumber: 10000,
        };
        this.axios
          .post("platform/hospital/getHospitaList", data)
          .then((res) => {
            this.hospitalList = res.data.list.map((item) => {
              return {
                hospital_id: item.hospital_id,
                hospital_name: item.hospital_name,
              };
            });
          });
      }
    },
    //剂型列表
    getHdDrugTypeList() {
      if (this.dosage_form) {
        let platform_type = 3;
        this.axios
          .post("platform/photograph/getDrugTypeList", { platform_type })
          .then((res) => {
            this.drugTypeList = res.data.list.map((item) => {
              item.drug_type_name = item.drug_type_name;
              item.dosage_form = item.drug_type;
              return item;
            });
          });
      } else {
        let data = {
          drug_id: this.drug_id,
          hospital_id: this.hospital_id,
          drug_type_pid: this.drug_type_pid,
        };
        this.axios
          .post("platform/hospital/getHdDrugTypeList", data)
          .then((res) => {
            this.drugTypeList = res.data;
          });
      }
    },
    //添加校正弹窗
    showDia() {
      this.ruleForm = {
        correct_time: "",
        correct_desc: "",
        num_symbol: "+",
        num: undefined,
        order_sn: "",
        remark: "",
        hospital_id: this.$route.query.hospital_id
          ? Number(this.$route.query.hospital_id)
          : "",
        dosage_form: this.$route.query.dosage_form
          ? Number(this.$route.query.dosage_form)
          : "",
        drug_id: this.$route.query.drug_id,
        correct_image: [],
      };
      this.dialog = true;
    },
    //提交校正
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.num_symbol == "-") {
            if (this.ruleForm.num > this.info.jafter) {
              this.$message.error("校正剂量超量");
              return false;
            }
          }
          let data = _.omit(this.ruleForm, ["num_symbol", "num"]);
          data.correct_time = dayjs(this.ruleForm.correct_time).format(
            "YYYY-MM-DD"
          );
          data.correct_num = this.ruleForm.num_symbol + this.ruleForm.num;
          data.correct_image = data.correct_image
            .filter((item) => item != "")
            .join(",");
          this.axios
            .post("platform/hospital/createCorrect", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("添加成功");
                this.dialog = false;
                this.getList();
                // this.getInfo();
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //删除
    delCorrectInfo(correct_id) {
      this.$confirm("删除不可恢复，请谨慎操作!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.axios
            .post("platform/hospital/delCorrectInfo", { correct_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("删除成功");
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    back() {
      history.back();
    },
    emitImg(data) {
      let { path, pic } = data;
      this.ruleForm.correct_image.push(pic);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogbox {
  padding: 20px;
}
</style>
<style lang="scss">
.correct-image {
  .el-form-item__content {
    height: 100px;
  }
  .image-box {
    display: flex;
    .cus-upload-img {
      margin-right: 10px;
    }
  }
}
</style>
